export default __webpack_public_path__ + "static/neem-150x150-6e49546972cb17dbd9739e635cf0b87b.png";